const angular = require('angular');

const OrderManagementService = require('./ordermanagement.service');
const { orderManagementComponentDefinition } = require('./order-management.component');
const { orderManagementSectionComponentDefinition } = require('./order-management-section.component');
const { orderManagementItemComponentDefinition } = require('./order-management-item.component');
const { orderManagementActionsComponentDefinition } = require('./order-management-actions.component');
const { orderManagementActionsPendingComponentDefinition } = require('./order-management-actions-pending.component');
const { orderManagementEditDeliveryComponentDefinition } = require('./order-management-edit-delivery.component');
const { orderManagementCountdownComponentDefinition } = require('./order-management-countdown.component');

angular.module('wowApp.shop')
    .service('OrderManagementService', ['Restangular', 'BreakpointsService', OrderManagementService])
    .component('wowOrderManagement', orderManagementComponentDefinition)
    .component('wowOrderManagementSection', orderManagementSectionComponentDefinition)
    .component('wowOrderManagementItem', orderManagementItemComponentDefinition)
    .component('wowOrderManagementActions', orderManagementActionsComponentDefinition)
    .component('wowOrderManagementActionsPending', orderManagementActionsPendingComponentDefinition)
    .component('wowOrderManagementEditDelivery', orderManagementEditDeliveryComponentDefinition)
    .component('wowOrderManagementCountdown', orderManagementCountdownComponentDefinition);



// WEBPACK FOOTER //
// ./src/order/ordermanagement/index.js